import Modal from "../../components/modal"
import UploadFiled from "../../components/fileduploader"
import { postAPI, uploadApi } from "../../api/api"
import { useState } from "react";
import Headline5 from "../../components/headings/Headline5";
import { REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common"

 const UploadHolidayList = (props: any) => {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [document, setDocument] = useState<string>()
    const { v4: uuidv4 } = require("uuid");


   const uploadFile = (e: any) => {
   
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let fileExtension = e.target.files[0].name.split(".").pop();
      let file = e.target.files[0]
      let type = file.type

      let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, "");

      let value = {
        "action":"putObject",
        "filename":fileName
      }
   
      postAPI( REACT_APP_CANDIDATE_FRELLANCER + '/getsignedurlforresume',value).then((data) => {
        let signedUrl = data.url;
        uploadApi(signedUrl, file, type).then((response: any) => {
          props.clickHandler(fileName)
            setDocument(fileName)
        })
      })
  };


    return (
        
        <Modal size={'small'} title={'Upload'} onClose={() => props.onClose()}>
             <Headline5>Upload Holiday List</Headline5>
         <div className="modal-file-uploader">
          <UploadFiled uploadFile={uploadFile} />
        </div>
        {/* <div className="popupAction">
          <Button variant="secondary" onClick={() => props.onClose()}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => props.onClose()}>
            Upload
          </Button>
        </div> */}
        </Modal>
   )
}
  export default UploadHolidayList

